// 绑定或新建医院帐号流程
export default [
  {
  path: '/bind/choose-patient',
  component: () => import('../pages/bind/choose-patient')
},
  {
  path: '/bind/switch-patient',
  component: () => import('../pages/bind/switch-patient')
},
  {
  path: '/bind/choose-hospital',
  component: () => import('../pages/bind/choose-hospital.vue')
},
  {
  path: '/bind/bind-hospital',
  component: () => import('../pages/bind/bind-hospital')
},
  {
  path: '/bind/hospital-account',
  component: () => import('../pages/bind/hospital-account')
},
  /**
   * 新建医院账号
   */
  {
    path: '/bind/hospital-new',
    component: () => import('../pages/bind/hospital-new')
  }
]



// WEBPACK FOOTER //
// ./src/router/bind.js